// Endpoints of the ai-agent service, relative to `AiAgentModuleConfig.apiBaseUrl`.
// The AG-UI route is the only supported entry point — Mastra's own /api/agents/*
// bypasses the server's setContext and the agent refuses to run without a principal.

export const AI_AGENT_API_COPILOTKIT = '/copilotkit';
export const AI_AGENT_API_FEEDBACK = '/feedback';
export const AI_AGENT_API_HEALTH = '/health';
